import { render, staticRenderFns } from "./SetShapes.vue?vue&type=template&id=691cfc06&scoped=true"
import script from "./SetShapes.vue?vue&type=script&lang=js"
export * from "./SetShapes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691cfc06",
  null
  
)

export default component.exports